import { Action } from '@ngrx/store';

export enum AuthActionTypes {
    INIT_TOKEN= '[Auth] INIT_TOKEN',
    LOG_IN_PENDING = '[Auth] LOG_IN_PENDING',
    LOGGED_IN = '[Auth] LOGGED_IN',
    LOG_OUT = '[Auth] LOG_OUT',
}

export class LogInPending implements Action {
    public type: string = AuthActionTypes.LOG_IN_PENDING;
}

export interface ILoggedInPayload {
    token: string;
}

export class InitToken implements Action {
    constructor(public payload: ILoggedInPayload) { }

    public type: string = AuthActionTypes.INIT_TOKEN;
}

export class LoggedIn implements Action {
    constructor(public payload: ILoggedInPayload) { }

    public type: string = AuthActionTypes.LOGGED_IN;
}

export class LogOut implements Action {
    public type: string = AuthActionTypes.LOG_OUT;
}

export type AuthActions =
    | LogInPending
    | LoggedIn
    | LogOut;
